module.exports = __webpack_public_path__ + "img/Facebook.783b7a48.png";